
  export const getLabelFromArray = (value, options) => {
    return(
    options.filter(o => o.value === value).map((filtered) => (
      filtered.label
    )))
  };